import { useCallback, useEffect } from 'react';
import {useLanguage} from "@/contexts/languageContext";
import objectUtil from "@/utils/objectUtil";

export const useAddField = (handleFormSubmit, type, formData) => {

    const { getLangObject } = useLanguage();

    const onAddField = useCallback(
        (e) => {
            const detail = e?.detail;
            handleFormSubmit((data) => {
                /** Formatting field into 1 per language
                 * {fr: fieldObject, en: fieldObject}
                 * */
                const langKeys = Object.keys(data).filter((key) => (
                    objectUtil.isObject(data[key]) &&
                    objectUtil.deepEqual(Object.keys(data[key]), Object.keys(getLangObject()))
                ));

                const formattedData = Object.keys(getLangObject()).reduce((acc, lang) => {
                    return ({
                        ...acc,
                        [lang]: {
                            ...data,
                            ...langKeys.reduce((acc, key) => {
                                return {...acc, [key]: data[key][lang]};
                            }, {})
                        }
                    })
                }, {});
                detail.onChange(formattedData);
                detail.onClose();
            });
        },
        [handleFormSubmit]
    );

    useEffect(() => {
        document.removeEventListener('addField', onAddField);
        document.addEventListener('addField', onAddField);
    }, [formData, onAddField, type]);

    useEffect(() => {
        document.addEventListener('addField', onAddField);
        return () => {
            document.removeEventListener('addField', onAddField);
        };
    }, [onAddField]);
};

export default useAddField;
